(function () {
  'use strict';
  const toggleClass = function (otherTabs, thisTab, className = 'active-panel') {

    for (const otherTab of otherTabs) {
      if(otherTab == thisTab){
        thisTab.parentElement.classList.toggle(className);        

      } else {
        otherTab.parentElement.classList.remove(className);
      }
    }
    radionChangeEvent();
  };

  const radionChangeEvent = function(){
    const accordionTabs = document.querySelectorAll('.accordion-radio');
    for(const accordionTab of accordionTabs){
      //accordionTab.parentElement.classList.remove('active-panel');
      accordionTab.addEventListener('change', function() {
        accordionTab.parentElement.classList.add('active-panel');           
      });
    }
     
  };

  const toggleVerticalTabs = function (panelWrapper,mobileTabs, mobileTab) {
      //console.log(mobileTab, mobileTab.parentElement.classList.contains('active-panel'));
      
      var activePanels = panelWrapper.querySelectorAll('.active-panel');
      console.log('length: ',activePanels.length);
      if(mobileTab.parentElement.classList.contains('active-panel') || activePanels.length == 0){
        //console.log('hide panel here ',mobileTab.dataset.target);
        mobileTab.parentElement.classList.toggle("active-panel");
        //tabContainer.querySelector(`#${mobileTab.dataset.target}`).style.display = "none";
        mobileTab.scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        toggleClass(mobileTabs, mobileTab);
        console.log('activate here');
      }
    
  };

  const toggleTabs = function (tabContainer) {
    var tabs = tabContainer.querySelectorAll('.accordion-btn');
    var mobileTabs = tabContainer.querySelectorAll('.accordion-mobile');    
    for (const tab of tabs) {
      tab.onclick = function() {
        tabContainer.scrollIntoView({
          behavior: "smooth"
        });
        toggleClass(tabs, tab);
      };
    }
    for (const mobileTab of mobileTabs) {
      mobileTab.onclick = function() {
        var panelWrapper = tabContainer.querySelector('.pannel-wrapper');
        toggleVerticalTabs(panelWrapper,mobileTabs, mobileTab);
        console.log('mobileTab clicked',panelWrapper);
      }
    }
  };

  const modeSwitcher = function (tabContainer, containerWidth) {    
    //console.log('mode switched');
    const accordionTabs = document.querySelectorAll('.accordion-radio');
    for(const accordionTab of accordionTabs) {
      var btns = document.querySelectorAll("[data-flag='"+ accordionTab.dataset.target +"']");
      for(const btn of btns) {
        if(accordionTab.checked){
          btn.parentElement.classList.add('active-panel');
          //console.log('checking...');
          //document.querySelector(`#${btn.dataset.target}`).style.display = "block";
        } else {
          btn.parentElement.classList.remove('active-panel');
        }
      }
    }
  };

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      modeSwitcher(entry.target, entry.contentRect.width);
    }
  });

  const tabPanelContainers = document.querySelectorAll('.tab-pannel-wrapper');
  for (const tabPanelContainer of tabPanelContainers) {
    const tabList = tabPanelContainer.querySelector('.button-wrapper');
    resizeObserver.observe(tabList);
    toggleTabs(tabPanelContainer);  
  }
})();